import { call, put, takeLatest } from 'redux-saga/effects';
import { GET_DELIVERY_AGGREGATOR, GET_DELIVERY_AGGREGATOR_SUCCESS, GET_DELIVERY_AGGREGATOR_ERROR } from '../constants';
import { appendLocaleInCMSRequest } from '../network';
/**
 * @function getDeliveryAggregator
 * @description Gets content for delivery aggregators
 * @param data {Object} data - {
 *   type: Called ACTION type
 *   payload: Object containing aggregator contentful data
 * }
 */
export function* getDeliveryAggregator(data) {
    try {
        let result = {};
        const { payload } = data;
        const response = yield call(payload.object.getEntries, appendLocaleInCMSRequest(payload.contentFull));
        if (response && response !== undefined && response !== null) {
            result = {
                ...result,
                deliveryAggregators: response,
            };
            yield put({
                type: GET_DELIVERY_AGGREGATOR_SUCCESS,
                response: result,
            });
        }
        else {
            yield put({
                type: GET_DELIVERY_AGGREGATOR_ERROR,
            });
        }
    }
    catch (error) {
        yield put({
            type: GET_DELIVERY_AGGREGATOR_ERROR,
        });
    }
}
export default function* deliveryAggregatorSaga() {
    yield takeLatest(GET_DELIVERY_AGGREGATOR, getDeliveryAggregator);
}
